export const NOT_FOUND_PATH = '/not-found'
